<script setup lang="ts">
const props = withDefaults(
    defineProps<{
        type?: Exclude<TCompTypes, 'Thirdly'>,
        size?: Exclude<TCompSizes, 'Large'>,
        variant?: Exclude<TVariants, 'error'>,
        prependIcon?: TIcon,
        appendIcon?: TIcon,
    }>(),
    {
        type: 'Primary',
        size: 'Medium',
        variant: 'primary',
    }
);
</script>

<template>
    <VariantColors :variant="props.variant">
        <template #default="{ variantColors }">
            <div
                class="w-fit flex-center gap-1 select-none"
                :class="[
                    $style['base-chip'],
                    variantColors,
                    $style[props.type],
                    $style[props.size],
                ]"
                v-bind="$attrs"
            >
                <Icon
                    v-if="props.prependIcon"
                    :name="props.prependIcon.name"
                    :class="props.prependIcon?.class"
                />

                <slot />

                <Icon
                    v-if="props.appendIcon"
                    :name="props.appendIcon.name"
                    :class="props.appendIcon?.class"
                />
            </div>
        </template>
    </VariantColors>
</template>

<style module>
.base-chip {
    color: var(--chip-text);
    background-color: var(--chip-bg);
}


/* Types */
.Primary {
    --chip-bg: var(--c-600);
    --chip-text: var(--c-50);
}

.Secondary {
    --chip-bg: var(--c-50);
    --chip-text: var(--c-700);
    border: 1px solid var(--c-300);
}

.Outline {
    --chip-bg: transparent;
    --chip-text: var(--c-600);
    border: 1px solid var(--c-600);
}


/* Sizes */
.Small {
    height: 22px;
    padding: 2px 8px;
    border-radius: 12px;
    composes: text-caption from global;
}
.Small :global(.iconify) {
    width: 16px;
    height: 16px;
}

.Medium {
    height: 32px;
    padding: 4px 8px;
    border-radius: 24px;
    composes: text-caption from global;
}
.Medium :global(.iconify) {
    width: 24px;
    height: 24px;
}
</style>